import { SVGProps } from 'react'

export const WpsEmojiSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M8 14A6 6 0 118 2a6 6 0 010 12zM0 8a8 8 0 1116 0A8 8 0 010 8zm5.535.684C5.304 8.608 5 8.79 5 9.034A2.967 2.967 0 007.967 12h.066A2.967 2.967 0 0011 9.033c0-.243-.304-.425-.535-.349C10.008 8.834 9.227 9 8 9c-1.227 0-2.008-.165-2.465-.316zM7 6a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z'
      fill='#F1A100'
      fillRule='evenodd'
    />
  </svg>
)
